// Return type page for submit post to database
export const GetTypePage = (state = null, action) => {
    switch (action.type) {
        case 'GET_TYPE_PAGE':
          return action.type_page;
        default:
          return state;
    }
}